<template>
  <div class="relative f-col" :class="{ 'h-full': !images }">
    <base-picture
      v-if="images"
      v-bind="images"
      class="grow"
      :fetchpriority
      fit="cover"
      :lazy
    />
    <cms-shared-hot-zones v-if="hasHotZones" :media />
    <div
      v-style:c="titleColor"
      class="flex justify-center"
      :class="[
        titleStyle,
        titlePosition === 'below-left' ? 'text-left' : 'text-center',
        titlePosition === 'middle' ? 'items-center' : 'items-end',
        {
          'absolute-0': images && isOverlay,
          [overlayPadding]: isOverlay,
          'sr-only': hideTitle,
        },
      ]"
    >
      <p v-style:bg="backdrop" :class="[blurClass, isOverlay ? backdropOverlayPadding : ['w-full', backdropBelowPadding]]">
        <span v-if="$feature.showTitleHtml" v-html="titleHtml" />
        <span v-else>{{ title }}</span>
      </p>
    </div>
    <base-link
      v-if="target?.url && !hasHotZones"
      :aria-label="title || target?.delocalizedTracking"
      class="absolute-0"
      :data-cta="target.delocalizedTracking"
      :to="target.url"
      @click="handleClick"
    />
  </div>
</template>

<script lang="ts" setup>
import type { SectionProvider } from '#content/contexts/section'
import type { CategoryCardContent } from '#types/components/cms/category-card'
import { ParentPromotionTrackingKey } from '#content/contexts/promotionTracking'
import { SectionContextKey } from '#content/contexts/section'

const { content, index = 0 } = defineProps<{ content: CategoryCardContent, index?: number }>()

const { $gtm, $feature } = useNuxtApp()
const {
  backdropBelowPadding,
  backdropOverlayPadding,
  overlayPadding
} = useAppConfig().components.cms.categoryCard.brandClasses

const { fetchpriority, lazy } = inject(SectionContextKey, {} as SectionProvider)

const {
  backdrop,
  backdropBlur,
  hideTitle,
  media,
  target,
  title,
  titleColor,
  titleHtml,
  titlePosition,
  titleStyle
} = content
const { images } = getResponsiveMedia(media)

const isOverlay = !titlePosition?.includes('below')

const hasHotZones = computed(() => Object.values(media || []).some((media) => media.enableImageMap))

const { parentHandlePromotionClick } = inject(ParentPromotionTrackingKey, {})
const handleClick = () => {
  $gtm.push('plpPage.onClickCategoryCard', title || '')
  parentHandlePromotionClick?.(`card${index + 1}`)
}

const blurClass = backdropBlur && (backdropBlur === 'low' ? 'backdrop-blur-xs' : 'backdrop-blur-md')
</script>
